/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_StartInputs */

const en_admin_resources_resource_allocations_start = /** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const de_admin_resources_resource_allocations_start = /** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const es_admin_resources_resource_allocations_start = /** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const fr_admin_resources_resource_allocations_start = /** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début`)
};

const nl_admin_resources_resource_allocations_start = /** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_start = en_admin_resources_resource_allocations_start;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_start = en_admin_resources_resource_allocations_start;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_start = en_admin_resources_resource_allocations_start;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_start = en_admin_resources_resource_allocations_start;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StartInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_start = en_admin_resources_resource_allocations_start;

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Admin_Resources_Resource_Allocations_StartInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_start = /** @type {((inputs?: Admin_Resources_Resource_Allocations_StartInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_StartInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_start(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_start(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_start(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_start(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_start(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_start(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_start(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_start(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_start(inputs)
	return ro_admin_resources_resource_allocations_start(inputs)
});
export { admin_resources_resource_allocations_start as "admin.resources.resource_allocations.start" }